import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.59 2.088a1 1 0 0 1 .706-.043l.114.043.88.389C21.174 4.163 24.095 5 26 5a2 2 0 0 1 1.994 1.85L28 7v7.333c0 4.952-1.852 8.838-5.002 11.739-2.067 1.903-4.36 3.113-6.366 3.778-.41.141-.855.141-1.254.004-2.016-.669-4.309-1.879-6.376-3.782-3.055-2.813-4.889-6.552-4.997-11.291L4 14.333V7a2 2 0 0 1 2-2c1.834 0 4.61-.776 8.283-2.34l.428-.183zM16 4.094l-.518.228c-3.954 1.715-7.015 2.61-9.23 2.674L6 7v7.333c0 4.369 1.602 7.731 4.356 10.267a15.9 15.9 0 0 0 5.326 3.243l.317.109.328-.112a15.9 15.9 0 0 0 4.62-2.636l.35-.295.347-.309c2.665-2.454 4.251-5.682 4.351-9.847l.005-.42V7l-.252-.004c-2.127-.061-5.033-.888-8.76-2.472l-.47-.202zm6.275 9.039a1 1 0 0 0-1.464-1.358l-6.143 5.843-2.977-2.841-.097-.081a1 1 0 0 0-1.284 1.527l3.666 3.5.093.079a1 1 0 0 0 1.287-.077l6.833-6.5z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconWarranty = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconWarranty);
export default Memo;
